import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './ReceptionModals.css';

/**
 * Forgotten reception mode PIN: the account holder proves it is them with
 * their account PASSWORD (or a reset token from the emailed code, passed in
 * as `resetToken`), then picks a new PIN. The server refuses a bare overwrite.
 *
 * mode="change": the CURRENT PIN instead of the password (passed as `password`).
 *
 * props: onSubmit({ password, pin }) → Promise; onClose; onEmailCode (optional)
 */
class ResetPinModal extends Component {
    state = { password: '', pin: '', confirmPin: '', error: '', isSubmitting: false };

    digits = (key) => (e) => {
        const v = e.target.value;
        if (/^\d{0,4}$/.test(v)) this.setState({ [key]: v, error: '' });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { password, pin, confirmPin } = this.state;
        const change = this.props.mode === 'change';
        if (change && !/^\d{4}$/.test(password)) return this.setState({ error: 'Enter your current 4-digit PIN.' });
        if (!this.props.resetToken && !password) return this.setState({ error: 'Enter your account password.' });
        if (pin.length !== 4) return this.setState({ error: 'The new PIN must be 4 digits.' });
        if (pin !== confirmPin) return this.setState({ error: "The PINs don't match." });
        this.setState({ isSubmitting: true });
        Promise.resolve(this.props.onSubmit({ password, pin }))
            .catch((err) => this.setState({ error: (err && err.message) || "That didn't work. Try again." }))
            .then(() => this.setState({ isSubmitting: false }));
    }

    render() {
        const { onClose, onEmailCode, resetToken, mode } = this.props;
        const change = mode === 'change';
        const { password, pin, confirmPin, error, isSubmitting } = this.state;
        return ReactDOM.createPortal(
            <div className="rm-modal-overlay" onClick={onClose}>
                <div className="rm-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="rm-modal-header">
                        <h3>{change ? 'Change PIN' : 'Reset PIN'}</h3>
                        <button className="rm-modal-close" onClick={onClose} type="button">&times;</button>
                    </div>
                    <div className="rm-modal-body">
                        <p>{resetToken ? 'Choose a new 4-digit PIN.' : change ? 'Enter the current PIN, then choose a new one.' : 'Enter the account password for this login, then choose a new 4-digit PIN.'}</p>
                        <form onSubmit={this.handleSubmit}>
                            {!resetToken && (
                                <div className="rm-form-group">
                                    <label className="rm-label" htmlFor="rm-password">{change ? 'Current PIN' : 'Account password'}</label>
                                    <input type="password" className="rm-input" id="rm-password" value={password}
                                        inputMode={change ? 'numeric' : undefined} maxLength={change ? 4 : undefined}
                                        onChange={(e) => this.setState({ password: e.target.value, error: '' })}
                                        autoComplete="current-password" disabled={isSubmitting} autoFocus />
                                </div>
                            )}
                            <div className="rm-form-group">
                                <label className="rm-label" htmlFor="rm-new-pin">New PIN</label>
                                <input type="password" inputMode="numeric" className="rm-input" id="rm-new-pin" value={pin}
                                    onChange={this.digits('pin')} maxLength={4} autoComplete="new-password" disabled={isSubmitting} autoFocus={!!resetToken} />
                            </div>
                            <div className="rm-form-group">
                                <label className="rm-label" htmlFor="rm-confirm-pin">Confirm new PIN</label>
                                <input type="password" inputMode="numeric" className="rm-input" id="rm-confirm-pin" value={confirmPin}
                                    onChange={this.digits('confirmPin')} maxLength={4} autoComplete="new-password" disabled={isSubmitting} />
                            </div>
                            {error && <span className="rm-error">{error}</span>}
                            <div className="rm-modal-footer">
                                {onEmailCode && !resetToken ? (
                                    <button type="button" className="rm-btn rm-btn--link" onClick={onEmailCode} disabled={isSubmitting}>Email me a code instead</button>
                                ) : (
                                    <button type="button" className="rm-btn rm-btn--secondary" onClick={onClose}>Cancel</button>
                                )}
                                <button type="submit" className="rm-btn rm-btn--primary" disabled={isSubmitting}>
                                    {isSubmitting ? 'Saving…' : change ? 'Change PIN' : 'Reset PIN'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>,
            document.body
        );
    }
}

export default ResetPinModal;
